var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"select",staticClass:"select-input",attrs:{"name":_vm.name},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(option,id){return _c('option',{key:id,domProps:{"value":option.value,"selected":_vm.elementSelect === option.value ? true : false}},[_vm._v(" "+_vm._s(option.text || option.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }